import client from './client';

export type SuppressionReason = 'bounce' | 'complaint' | 'manual';

export interface SuppressionEntry {
  id: number;
  email: string;
  reason: SuppressionReason | string;
  source_rid?: string;
  created_at: string;
}

export interface SuppressionImportResult {
  success: boolean;
  imported: number;
  skipped: number;
}

export interface SMSOptOutEntry {
  id: number;
  phone: string;
  reason: string;
  created_at: string;
}

export const suppressionsApi = {
  getAll: () =>
    client.get<SuppressionEntry[]>('/suppressions/'),

  getSMSOptOuts: () => client.get<SMSOptOutEntry[]>('/suppressions/phones'),
  removeSMSOptOut: (id: number) => client.delete(`/suppressions/phones/${id}`),

  create: (email: string, reason?: SuppressionReason) =>
    client.post('/suppressions/', { email, reason }),

  remove: (id: number) =>
    client.delete(`/suppressions/${id}`),

  /**
   * Bulk import from a pasted newline/comma separated list. The server also
   * accepts an array, but the page sends a string.
   */
  importEmails: (emails: string, reason?: SuppressionReason) =>
    client.post<SuppressionImportResult>('/suppressions/import', { emails, reason }),

  /**
   * Bulk import from an uploaded CSV/text file, matching the multipart
   * upload convention used by /api/import/group.
   */
  importFile: (file: File, reason?: SuppressionReason) => {
    const formData = new FormData();
    formData.append('file', file);
    if (reason) {
      formData.append('reason', reason);
    }
    return client.post<SuppressionImportResult>('/suppressions/import', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
